import { render, staticRenderFns } from "./prospeccao-extras.vue?vue&type=template&id=a35b1e12&scoped=true"
import script from "./prospeccao-extras.vue?vue&type=script&lang=js"
export * from "./prospeccao-extras.vue?vue&type=script&lang=js"
import style0 from "./prospeccao-extras.vue?vue&type=style&index=0&id=a35b1e12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a35b1e12",
  null
  
)

export default component.exports